import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { inferQueryKeys } from '@lukemorales/query-key-factory';
import type { MaybeRef } from 'vue';
import type { LocaleCode } from '~/constants/i18n';

export const settings = createQueryKeys('settings', {
  workingHours: null,
});

export const services = createQueryKeys('services', {
  allPaginated: (query?: any) => [query],
  // Public catalog reads — the UI locale is part of the key (the API localizes via `?locale=`).
  list: (locale: MaybeRef<LocaleCode>) => [locale],
  detail: (idOrSlug: MaybeRef<string>, locale: MaybeRef<LocaleCode>) => [idOrSlug, locale],
  content: (idOrSlug: MaybeRef<string>, locale: MaybeRef<LocaleCode>) => [idOrSlug, locale],
});

export const portfolio = createQueryKeys('adminPortfolio', {
  allPaginated: (query?: any) => [query],
});

export const packages = createQueryKeys('adminPackages', {
  allPaginated: (query?: any) => [query],
});

export const pointsOfInterest = createQueryKeys('adminPointsOfInterest', {
  allPaginated: (query?: any) => [query],
});

export type SettingsKeys = inferQueryKeys<typeof settings>;
export type ServicesKeys = inferQueryKeys<typeof services>;
export type PortfolioKeys = inferQueryKeys<typeof portfolio>;
export type PackagesKeys = inferQueryKeys<typeof packages>;
export type PointsOfInterestKeys = inferQueryKeys<typeof pointsOfInterest>;
